// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__vyKNP","form":"styles_form__182GG"};